const EXTERNAL_LINK_PATTERN = /^https?:\/\//i;

/**
 * Ссылка внешняя, если она начинается с http:// или https://.
 *
 * Проверять нужно именно сырой url (как он пришёл из API): `localizeLink`
 * прогоняет путь через `new URL(path, location.href)` и делает абсолютным
 * любой относительный путь, после чего отличить внешнюю ссылку уже нельзя.
 */
const checkIsExternalLink = (
    url: string
): boolean => EXTERNAL_LINK_PATTERN.test(url.trim());

export { checkIsExternalLink };
